import { createFileRoute } from "@tanstack/react-router";

import { AdminComfyuiWorkersScreen } from "@/features/admin/screens/AdminComfyuiWorkers";

export const Route = createFileRoute(
  "/_authenticated/(admin)/admin/comfyui-workers",
)({
  component: AdminComfyuiWorkersScreen,
});
